import { AppModules } from 'appContainer/types';
import { stringParam } from 'router/declarative/paramRegistry';
import {
  type IndexRouteContent,
  type PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';
import { tabParam } from '../dashboard2/types';

// Shared content loader for all integration views
const integrationContent = async () =>
  (await import('./IntegrationsLayout')).IntegrationsLayout;

const connectionsBuilder = async () =>
  (await import('integrations/import-builder/pages/ConnectionBuilder'))
    .ConnectionBuilder;

export const routes = {
  path: '/integrations',
  appModule: AppModules.INTEGRATIONS,
  title: 'Integrations',
  searchParams: { query: stringParam },
  children: [
    {
      path: { index: true },
      content: async (): IndexRouteContent =>
        (await import('../dashboard/pages/dashboard')).Dashboard,
    },
    {
      path: '/dashboard',
      searchParams: { tab: tabParam },
      content: async (): PathRouteContent =>
        (await import('../dashboard2')).Dashboard,
    },
    {
      path: '/history',
      content: async () => (await import('../dashboard/pages/history')).index,
    },
    {
      path: '/:integrationId',
      children: [
        {
          path: { index: true },
          content: integrationContent,
        },
        // Connection routes (from OverviewRoute + ConnectionRoute enums)
        {
          path: '/connections',
          children: [
            {
              path: { index: true },
              content: integrationContent,
            },
            {
              path: '/build',
              content: connectionsBuilder,
            },
          ],
        },
        // Overview routes (from OverviewRoute enum)
        { path: '/configurations', content: integrationContent },
        { path: '/schedules', content: integrationContent },
        // ITPedia-specific routes (standalone integration with custom flow)
        // At the moment we're following the old route implementation with
        // with a bridge so we need keep it this way for now.
        // Later we will migrate the navigation with new router and
        // redefine the routes and its structure.
        { path: '/field-mapping', content: integrationContent },
        { path: '/summary-sync', content: integrationContent },
        { path: '/success', content: integrationContent },
        { path: '/failed', content: integrationContent },
        // Import routes (from ImportRoute enum)
        {
          path: '/import',
          children: [
            { path: { index: true }, content: integrationContent },
            { path: '/select-data', content: integrationContent },
            { path: '/configure', content: integrationContent },
            { path: '/test', content: integrationContent },
            { path: '/import-and-schedule', content: integrationContent },
          ],
        },
        // Export routes (from ExportRoute + NewExportRoutes enums)
        {
          path: '/export',
          children: [
            { path: { index: true }, content: integrationContent },
            { path: '/select-data', content: integrationContent },
            { path: '/configure', content: integrationContent },
            { path: '/test', content: integrationContent },
            { path: '/export', content: integrationContent },
            { path: '/data-selection', content: integrationContent },
            { path: '/field-mapping', content: integrationContent },
            { path: '/review-export', content: integrationContent },
            { path: '/export-and-schedule', content: integrationContent },
            { path: '/success', content: integrationContent },
            { path: '/failed', content: integrationContent },
          ],
        },
      ],
    },
  ],
} as const satisfies RouteNode;
